import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { RegisterAccountDto, UpdateAccountDto, ChangePasswordDto, ChangeCountyDto, SendPasswordResetCodeDto } from '../models/register-models';
import { WebApiResponse } from 'src/app/core/api/models/api-model';
import { AccountServicesModule } from '../../account-services.module';



@Injectable({
	providedIn: AccountServicesModule
})
export class RegisterProxyService {

	constructor(private httpClient: HttpClient) { }

	registerAccount(registerAccountDto: RegisterAccountDto): Observable<WebApiResponse<any>> {
		const url = `${environment.api.fasttrackApi}/services/app/Account/Register`;
		return this.httpClient.post(url, registerAccountDto).pipe(
			map(res => res as WebApiResponse<object>)
		);
	}

	updateAccount(updateAccountDto: UpdateAccountDto) {
		const url = `${environment.api.fasttrackApi}/services/app/Profile/UpdateCurrentUserProfile`;
		return this.httpClient.put(url, updateAccountDto).pipe(
			map(res => res as WebApiResponse<object>)
		);
	}

	changePassword(changePasswordDto: ChangePasswordDto) {
		const url = `${environment.api.fasttrackApi}/services/app/Profile/ChangePassword`;
		return this.httpClient.post(url, changePasswordDto).pipe(
			map(res => res as WebApiResponse<object>)
		);
	}

	changeCounty(changeCountyDto: ChangeCountyDto): Observable<WebApiResponse<any>> {
		const url = `${environment.api.fasttrackApi}/services/app/Profile/UpdateCounty`;
		return this.httpClient.put(url, changeCountyDto);
	}

	getAccount() {
		const url = `${environment.api.fasttrackApi}/services/app/Profile/GetCurrentUserProfileForEdit`;
		return this.httpClient.get(url).pipe(
			map(res => res as WebApiResponse<UpdateAccountDto>)
		);
	}

	sendPasswordResetCode(sendPasswordResetCodeDto: SendPasswordResetCodeDto): Observable<WebApiResponse<void>> {
		const url = `${environment.api.fasttrackApi}/services/app/Account/SendPasswordResetCode`;
		return this.httpClient.post(url, sendPasswordResetCodeDto);
	}
}
